import React from "react";

const GameStartContainer = () => {
	return <div>TENNIS Game Start</div>;
};

export default GameStartContainer;
